<template>
  <div >
    <div
         v-loading="loading"
         element-loading-text="Loading"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(255, 255, 255, 0.3)"
         v-loading.fullscreen.lock="fullscreenLoading">
    </div>
    <div class="main">
          <div class="left-section">
            <div class="news-list-bg">
              <div class="content-bg" id="content-bg">
                <h3 class="content-title">{{content.title}}</h3>
                <div class="price">
                  <span v-show="priceUsd">{{this.$t('common.Price')}}：<i>{{content.usd}}</i>{{this.$t('common.USD')}} </span>
                  <span v-show="priceRmb"><i>{{content.rmb}}</i>{{this.$t('common.RMB')}} </span>
                  <span v-show="priceGold"><i>{{content.gold}}</i>{{this.$t('common.Coins')}} </span>
                </div>
                <div class="content-info"><span>{{this.$t('common.Author')}}：{{content.author}}</span><span>{{this.$t('common.time')}}：{{content.createTime}}</span> <span>{{this.$t('common.Views')}}：{{content.hits}}</span>
                </div>
                <p class="content" id="content" v-html="content.content"></p>
                <span>{{this.$t('common.Source')}}：{{content.source}}</span>

                <!--文章隐藏内容，点击购买-->
                <span class="hidden-content" v-show="buyShow" @click="buyArticle">{{this.$t('common.hiddenContent')}}</span>

              </div>
            </div>


            <!--评论表单-->
            <commentForm :articleId="articleId"/>
            <!--评论-->
            <comment :commentList="commentList"/>
          </div>
          <div class="right-section">
            <!--本站推荐-->
            <recommend/>

            <!--右侧广告位-->
            <!--<div style="margin-bottom:10px;" class="right-adv">-->
              <!--<div v-for="(item,index) in 4" :key="index" class="right-adv">-->
                <!--<img src="../assets/homepage/adv1.jpg"/>-->
              <!--</div>-->
            <!--</div>-->
            <!--热门评论-->
            <hot-Comment/>
          </div>
    </div>
    <!--购买文章弹框-->
    <el-dialog :title="$t('userInfo.purchase')" :visible.sync="dialogFormVisible">
      <el-form :model="buyForm" label-width="100px" class="form-style" >
        <el-form-item :label="$t('common.payment')" class="label-style">
          <div class="radio-style">
            <el-radio v-model="radio" label="usd" v-show="isUsd">{{this.$t('common.USD')}}</el-radio>
            <el-radio v-model="radio" label="rmb" v-show="isRmb">{{this.$t('common.RMB')}} </el-radio>
            <el-radio v-model="radio" label="gold" v-show="isGold">{{this.$t('common.Coins')}}</el-radio>
          </div>
        </el-form-item>
        <el-form-item :label="$t('common.Price')" class="label-style">
          <div class="price-style">
            <span v-show="isUsd">{{buyForm.usd}}{{this.$t('common.USD')}}</span>
            <span v-show="isRmb">{{buyForm.rmb}}{{this.$t('common.RMB')}}</span>
            <span v-show="isGold">{{buyForm.gold}}{{this.$t('common.Coins')}}</span>
          </div>
        </el-form-item>

        <el-form-item :label="$t('common.Balance')"  class="label-style">
          <div class="price-style">
            <span>{{buyForm.overUsd}}{{this.$t('common.USD')}}</span>
            <span>{{buyForm.overRmb}}{{this.$t('common.RMB')}}</span>
            <span>{{buyForm.overGold}}{{this.$t('common.Coins')}}</span>
          </div>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{this.$t('common.Cancel')}}</el-button>
        <el-button type="success" @click="buySubmit">{{this.$t('common.Ok')}}</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>
  import axios from '../axios'
  import comment from './comment/comment.vue'
  import recommend from './comment/recommend.vue'
  import hotComment from './comment/hotComment.vue'
  import commentForm from './comment/commentForm.vue'

  export default {
    name: "contentpage",
    data() {
      return {
        loading: true,
        fullscreenLoading: true,
        content: [],
        commentList: [],
        url: '',
        articleId: '',
        radio: '',
        dialogFormVisible: false,
        buyShow: false,
        isUsd: false,
        isRmb: false,
        isGold: false,
        priceUsd: false,
        priceRmb: false,
        priceGold: false,
        buyForm: {
          rmb: '0',
          usd: '0',
          gold: '0',
          overUsd: '0',
          overRmb: '0',
          overGold: '0',
        },
        formLabelWidth: '120px'
      }
    },
    components: {comment, recommend, hotComment, commentForm},
    created: function () {
      this.getContent();
    },
    computed: {
      author () {
        return this.$store.state.dialogLoginVisible;
      }
    },
    updated() {
      this.imgSize();
    },
    methods: {
      getContent() {
        let id = this.$route.params.id;//跳转详情内容ID
        this.articleId = id;
        let _this = this;
        //获取新闻列表片数据
        axios({
          method: "get",
          url: this.$store.state.apiBasePath + '/article/' + id
        }).then(function (res) {
          if (res.data.code === 200) {
            _this.loading=false;
            _this.fullscreenLoading=false;
            let resData = res.data.data;
            _this.content = resData;
            _this.commentList = resData.commentList;
            _this.buyForm.usd = resData.usd;
            _this.buyForm.rmb = resData.rmb;
            _this.buyForm.gold = resData.gold;
            if (!resData.have) {
              _this.buyShow = true;
            }
          } else {
            _this.$message({
              type: 'error',
              title: _this.$t('message.Error'),
              message: res.data.msg,
              showClose: true,
              offset:300,
              duration:3000,
            });
          }
        });
        //求情支付方式
        axios.get(this.$store.state.apiBasePath + '/buy/allowPayment').
          then(function (res){
          if (res.data.code === 200) {
          let resDate = res.data.data;
          if (resDate.usd == true) {
            _this.priceUsd = true;
          }
          if (resDate.rmb == true) {
            _this.priceRmb=true;
          }
          if (resDate.gold == true) {
            _this.priceGold=true;
          }
        }
        })
      },

      //用户购买文章
      buyArticle() {
        let _this = this;
        var token = localStorage.getItem('loginToken');
        if (token != null && token != '') {
          axios.get(this.$store.state.apiBasePath + "/user/info")
            .then(function (res) {
              _this.dialogFormVisible = true;
              var resData = res.data;
              if (resData.code === 200) {
                _this.buyForm.overUsd = resData.data.usd;
                _this.buyForm.overRmb = resData.data.rmb;
                _this.buyForm.overGold = resData.data.gold;
              }
            });
          axios.get(this.$store.state.apiBasePath + '/buy/allowPayment')
            .then(function (res) {
              if (res.data.code === 200) {
                let resDate = res.data.data;
                if (resDate.usd == true) {
                  _this.isUsd = true;
                  _this.priceUsd = true;
                }
                if (resDate.rmb == true) {
                  _this.isRmb = true;
                  _this.priceRmb=true;
                }
                if (resDate.gold == true) {
                  _this.isGold = true;
                  _this.priceGold=true;
                }
              }
              else {
                _this.$message({
                  type: 'error',
                  title: _this.$t('message.Error'),
                  message: res.data.msg,
                  showClose: true,
                  offset:300,
                  duration:3000,
                });
              }
            })
        } else {
          _this.$message({
            type: 'warning',
            title: _this.$t('message.warning'),
            message: _this.$t('message.login'),
            showClose: true,
            offset:300,
            duration:3000,
            onClose:function () {
              _this.$store.commit('login_dialog');
            }
          });
        }
      },
      // 点击购买按钮
      buySubmit() {
        this.dialogFormVisible = false;
        let id = this.$route.params.id;//跳转详情内容ID
        this.articleId = id;
        let _this = this;
        axios.post(this.$store.state.apiBasePath + '/buy/article?payment=' + this.radio + '&articleId=' + this.articleId)
          .then(function (res) {
            if (res.data.code === 200) {
              _this.$message({
                type: 'success',
                title: _this.$t('message.SuccessPurchased'),
                message:_this.$t('message.SuccessPurchased'),
                showClose: true,
                offset:300,
                duration:3000,
                onClose:function () {
                  // 购买成功，页面刷新
                  window.location.reload();
                }
              });
            } else {
              _this.$message({
                type: 'error',
                title: _this.$t('message.Error'),
                message: res.data.msg,
                showClose: true,
                offset:300,
                duration:3000,
              });
            }
          })
      },
      // 图片超出屏幕
      imgSize() {
        //图片宽度超出，设置图片宽度
        var imgwidth = "100%";
        //获取P标签里面所有img标签
        var img = document.getElementById("content").getElementsByTagName("img");
        var a = document.getElementById("content").getElementsByTagName("a");

        // 遍历P标签，超过宽度设置图片宽度
        if(img.length>0){
          for (var i=0;i<img.length;i++) {
            if(a[i] != undefined){
              img[i].width = imgwidth;
              img[i].style.width = imgwidth;
              img[i].removeAttribute("height");
              img[i].title = "View";
              img[i].style.cursor = "pointer";
              img[i].border = 0;
              img[i].onclick = function (e) {
                window.open(this.src);
              }
            }
          }
        }

      }
    }
  }

</script>

<style scoped>
  .right-section {display: none;}

  img {
    max-width: 100%;
  }

  .main {
    width: 1170px;
    margin: 15px auto 15px auto;
    display: flex;
    justify-content: space-between;
  }

  .left-section {
    /*margin-right: 10px;*/
    width:100%;
  }

  .news-list-bg {
    margin-bottom: 10px;
    padding: 10px 10px;
    /*border: #e5e5e5 1px solid;*/
    background: #fff;
  }

  .content-bg {
    padding: 15px 0;
  }

  .content-title {
    color: #000;
    font-size: 28px;
    text-align: center;
    font-family: "Helvetica Neue", Helvetica, sans-serif;;
  }

  .price {
    text-align: center;
    font-size: 16px;
    margin: 15px auto;
  }

  .price span {
    margin: 0 15px;
  }

  .price span i {
    color: #e60000;
    font-style: normal;
    font-weight: bold;
    margin-right: 5px;
  }

  .title-label {
    font-weight: bold;
  }

  .content-info {
    font-size: 14px;
    color: #777;
    text-align: center;
  }

  .content-info span {
    margin: 0 15px;
  }

  .content {
    margin-top: 30px;
    text-align: inherit;
    font-size: 14px;
    line-height: 26px;
    word-break: break-word;
    color:#555;
    font-family: "Helvetica Neue", Helvetica, sans-serif;;
  }

  .content p, .content span {
    margin: 0 0;
    font-family: "Helvetica Neue", Helvetica, sans-serif;;
  }

  .content-bg img {
    display: block;
    max-width: 100%;
    word-break: break-word;
  }

  .hidden-content {
    text-decoration: underline;
    color: #e60000;
    font-size: 14px;
    margin-top: 20px;
    display: block;
  }

  .hidden-content:hover {
    cursor: pointer;
  }

  .news-img-bg h3 {
    font-size: 20px;
    color: #000;
    margin-left: 10px;
    text-align: left;
    line-height: 40px;
  }

  .news-img {
    width: 148px;
    height: 112px;
    display: block;
  }

  .news-img img {
    width: 148px;
    height: 112px;
    display: block;
  }

  .news-list-text {
    font-size: 14px;
    text-align: justify;
    display: flex;
    flex-wrap: wrap;
  }

  .news-list-text li {
    width: 50%;
  }

  .news-list-text li a {
    line-height: 35px;
    position: relative;
    padding: 0 15px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    color: #2c3e50;
    text-decoration: none;
    display: block;
  }

  .radio-style,.price-style {
    border-left: #ddd 1px solid;
    line-height: 60px;
    padding-left: 15px;
  }
  .radio-style .el-radio {
    width: 100px;
    display: inline-block;
    margin-right: 0;
    }

  .price-style span {
    width: 100px;
    display: inline-block;
    }
  .price-tag {
    /*border-left: #ddd 1px solid;*/
    line-height: 60px;
    padding-left: 15px;
  }
  .price-tag span {
    margin-right: 25px;
  }
  .form-style {
    border: #e5e5e5 1px solid;
    margin: 0 30px;
  }
  .label-style {
    border-bottom: #e5e5e5 1px solid;
    margin-bottom: 0;
    line-height: 60px;
  }
  .label-style .el-form-item__label{
    line-height: 60px;
  }
  .label-style:last-child {
    border: none;
  }


  @media screen and (max-device-width: 1024px) {
    .main {
      width: 100%;
      display: block;
    }
    .left-section{width: auto}
    .news-list-bg {
      width: 100%;
      padding:0 0;
    }
    .left-section {
      margin:0 15px 10px 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/contentPage.vue